import * as React from "react";
import { useLayoutEffect, useRef } from "react";
import styled from "styled-components";
import * as h from "../../_themes/helpers";

interface IProps {
  value: number;
}

export function Track({ value }: IProps) {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    // let's avoid using style-component for expensive calculations
    // use transform scale instead for high performace results
    ref.current.style.transform = `scale(1, ${value * 0.01})`;
  }, [value]);

  return <TrackView ref={ref} />;
}

const TrackView = styled.div`
  pointer-events: none;
  height: 100%;
  width: 0.3em;
  background-color: ${h.getBackgroundColor(
    "sliderTrackStyle",
    "slider.trackStyle"
  )};
  position: absolute;
  left: calc(50% - 0.15em);
  bottom: 0;
  z-index: 2;
  will-change: transform;
  transform-origin: bottom;
  transform: scale(1, 1);
`;
